// If you make changes here, don't forget to update the backend Enum as well.
export enum DisabledFeatures {
	PAYMENTS = 'Payments',
	PURCHASE_STUDENT_PAY = 'PURCHASE_STUDENT_PAY',
	PURCHASE_LICENSE = 'PURCHASE_LICENSE'
}
